export default "__VITE_ASSET__CpNcHSCI__"